// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"35e5a22f8887db012511","532":"0f318dfb708d55792cab","691":"17d376092ab95160f99c"}[chunkId] + ".js";
};